import Field from '../field/field.vue';

export default {
    name: 'Level',
    props: {
        selected_level: Object
    },
    components: {
        'field': Field,
    },
    computed: {
        is_visible_level() {
            return this.selected_level.fields.filter(x => { return x.isHidden }).length != this.selected_level.fields.length;
        }
    },
    data() {
        return {
        };

    },
    methods: {
    },
    mounted() {
    },
};



// WEBPACK FOOTER //
// ./src/components/user/dashboard/pages/races/view-race/level/level.js